export default {"src":"/_next/static/media/Wednesday.a5326079.svg","height":1515,"width":1300};